import { ajax } from '../index'

/**
 * Csotd相关接口
 */
export default {
  // 获取页面面包屑
  getBreadcrumb(type: string) {
    return ajax.get('api', `/api/v1/breadcrumb/${type}`, {})
  },

  // 获取CSOTD商品数据
  getCrazyDeal() {
    return ajax.get('api', `/api/v1/product/crazy-deal/view`, {})
  },

  // 获取TopSeller商品数据
  getTopSeller() {
    return ajax.get('api', `/api/v1/mooncake/top-seller`, {})
  },

  // 获取Featured Deals模块数据
  getFeaturedDeals() {
    return ajax.get('api', `/api/v1/product/list/feature`, {})
  },

  // 获取Hot Scheme模块数据
  getHotScheme() {
    return ajax.get('api', `/api/v1/scheme/hot`, {})
  }
}